import { gql } from "@apollo/client";
import { useSuspenseQuery } from "@apollo/client/react";

import GQLApplications from "./Applications.graphql";

/** An application (branded app) as the Document Exports page needs it: templates belong to one. */
export interface ExportsApplication {
    id: string;
    /** The app's subdomain label (knauf.app.bimproject.cloud -> "knauf"); the template folder. */
    domain: string;
    name: string;
    /** Brands the app sells; PIM roles on any of them grant access to its templates. */
    brandIDs: string[] | null;
}

export default function useApplicationsForExports() {
    return useSuspenseQuery<{ applications: ExportsApplication[] }>(gql(GQLApplications)).data.applications;
}
